import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInfoResponse, isAuthenticated } from "utils/common";
import { saveUserInfo } from "features/User/userSlice";
import contactAPI from "api/contactAPI";
import PATH from "constants/path";

const saveContact = createAction("SAVE_CONTACT");

const getCMS = createAsyncThunk(
  "GET_CMS",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await contactAPI.getCMS();
      if (isAuthenticated()) {
        dispatch(saveUserInfo(getInfoResponse(res)));
      }
      if( res.sorrypage == '0') {
        return { 
          data: { isInLine: true }
        };
      }
      
      return {
        data: res.data
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const postContact = createAsyncThunk(
  "POST_CONTACT",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      let isInLine = false;
      const { data, history } = _arg;
      if (isAuthenticated()) {
        const res = await contactAPI.postContactAuth(data);
        dispatch(saveUserInfo(getInfoResponse(res)));
        if( res?.sorrypage == '0') {
          isInLine = true;
        }
      } else {
        const res = await contactAPI.postContact(data);
        if( res?.sorrypage == '0') {
          isInLine = true;
        }
      }
      if(!isInLine){
        return history.push(PATH.CONTACT_DONE);
      }
      return {
        isInLine: isInLine,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  info: null,
  cms: null,
  isInLine: false
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  extraReducers: {
    [saveContact]: (state, action) => {
      state.info = action.payload;
    },
    [postContact.fulfilled]: (state) => {
      if(!action?.payload?.isInLine){
        state.info = null;
      }
      state.isInLine = action?.payload?.isInLine || false;
    },
    [getCMS.fulfilled]: (state, action) => {
      state.cms = action.payload.data;
      state.isInLine = action.payload.data.isInLine;
    },
  },
});

const { reducer } = contactSlice;
export { saveContact, postContact, getCMS };
export default reducer;
